import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DsLoaderService {
  /**
   * A Subject for the loader state Observable that allows values to be
   * multicasted to many Observers.
   *
   * You can subscribe to get the loader state or use it directly with a AsyncPipe.
   *
   */
  public loaderState = new Subject<boolean>();

  /**
   * Call next to feed the loader state,
   * to show/hide the http requests loader.
   *
   * @param state the loader state
   */
  setloaderState(state: boolean) {
    this.loaderState.next(state);
  }
}
